import React, { useContext } from 'react';
import { styled } from "@mui/material/styles";
import CardComp from './Card';
import { ScrollMenu, VisibilityContext } from 'react-horizontal-scrolling-menu';
import { Typography, IconButton, Container } from '@mui/material';
import 'react-horizontal-scrolling-menu/dist/styles.css';
import ArrowCircleRightRoundedIcon from '@mui/icons-material/ArrowCircleRightRounded';
import ArrowCircleLeftRoundedIcon from '@mui/icons-material/ArrowCircleLeftRounded';



const LeftArrow = () => {
  const { scrollPrev } = useContext(VisibilityContext);

  return (
    <IconButton sx={{color:'black'}} onClick={() => scrollPrev()} >
        <ArrowCircleLeftRoundedIcon />
    </IconButton>
  );
};

const RightArrow = () => {
  const { scrollNext } = useContext(VisibilityContext);

  return (
    <IconButton sx={{color:'black'}} onClick={() => scrollNext()} >
        <ArrowCircleRightRoundedIcon />
    </IconButton>
  );
};

const StyledContainer = styled(Container)(({ theme }) => ({
    display: 'flex',
    flexDirection: 'row',
    justifyContent: 'space-around'  
  }));

const HorizontalScrollbar = ({articles}) => (
    <>

        {/*<StyledContainer>
            <Typography variant='h4' color="text.primary" > Articles for Catergory 1 </Typography>
        </StyledContainer>*/}
    
        <ScrollMenu LeftArrow={LeftArrow} RightArrow={RightArrow}>

                {articles.map( (article) => (
                   <div key={article.id}>
                        <CardComp article={article} />
                    </div>
                ) )} 

        </ScrollMenu>
  </>
);

export default HorizontalScrollbar;